import { Datalayer, DatalayersMap, DatalayerZone, IGeometryInstance } from "../../../omnia"
import { cleanupFeature, cleanupFeatures } from "../../../utils"
import { IModifyTool } from "../types"
import { DeleteHolesOp } from "./deleteHoles"

import IMapTopologyService = omnia.map.IMapTopologyService
import { ol_geom } from "@omnia/exports/openlayers"

export class ModifyOperation {

    public tools: IModifyTool[]

    constructor(private map: DatalayersMap, private layer: Datalayer, private topo: IMapTopologyService, private _outerGeometry: () => ol_geom.Geometry) {
    }

    get outerGeometry() {
        return this._outerGeometry()
    }

    start(zone: DatalayerZone) {

        this.tools = null

        if (zone && zone.feature) {

            zone.setInitialState()
            cleanupFeature(zone.feature)
            this.map.startEditFeature(zone.feature, true)
            this.setupTools(zone)

        }

    }

    stop() {

    }

    notifyZoneChanged(zone: DatalayerZone) {
        this.setupTools(zone)
    }

    executeTool(tool: IModifyTool) {
        tool.execute()
        this.tools = this.tools.filter(t => t.canExecute())
    }

    private setupTools(zone: DatalayerZone) {

        const zones = this.layer.zones

        const tools = [
            new DeleteHolesOp(zone, zones, this.topo)
        ].filter(t => t.canExecute())

        this.tools = tools

    }


    commit(zone: DatalayerZone) {

        this.map.commitEdit()

        try {
            this.trimTargetZone(zone)
        }
        catch (e) {
            console.error("trimTargetZone", e)
        }

        try {
            this.removeOverlaps(zone)
        }
        catch (e) {
            console.error("removeOverlaps", e)
        }

        this.createMissingZones()

        cleanupFeatures(this.layer.getFeatures())

        return true

    }

    private trimTargetZone(targetZone: DatalayerZone) {

        return omnia.map.trimZoneGeometry(targetZone, this.outerGeometry, this.topo)

    }

    private removeOverlaps(targetZone: DatalayerZone) {

        omnia.map.removeOverlaps(
            targetZone,
            this.layer.zones,
            zones => this.layer.removeZones(zones),
            (geom, zone) => this.createNewZone(geom, zone),
            this.topo
        )

    }

    private createMissingZones() {

        return createMissingZones(this.layer, this.topo, this.outerGeometry)

    }

    private createNewZone(geometry: ol_geom.Geometry, initialZone: DatalayerZone): DatalayerZone {

        return createNewZone(this.layer, geometry, initialZone)

    }

}

export function createMissingZones(layer: Datalayer, topo: IMapTopologyService, outerGeometry: ol_geom.Geometry | IGeometryInstance) {

    omnia.map.createMissingZones(
        layer.zones,
        topo,
        outerGeometry,
        geom => createNewZone(layer, geom, undefined)
    )

}


function createNewZone(layer: Datalayer, geometry: ol_geom.Geometry, initialZone: DatalayerZone): DatalayerZone {

    let zone = layer.createNewZoneWithGeometry(geometry)

    if (initialZone) {
        zone.value = initialZone.value
    }

    return zone

}
